var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.00391V11.3116M12.5 11.3116L9.73071 8.54248M12.5 11.3116L15.2692 8.54248M15.9615 5.08081H20.8077C21.19 5.08081 21.5 5.39077 21.5 5.77312V16.85C21.5 17.2323 21.19 17.5423 20.8077 17.5423H4.19231C3.80996 17.5423 3.5 17.2323 3.5 16.85V5.77312C3.5 5.39077 3.80996 5.08081 4.19231 5.08081H9.03846M11.1153 17.5425L9.73071 21.004M13.8846 17.5425L15.2693 21.004M8.34619 21.0039H16.6539",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.885f743f8953355091b993fe258e00c1.svg";
export { ForwardRef as ReactComponent };